var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RightInfoPanelGeneric',{attrs:{"value":_vm.value,"title-key":'common.products',"items":_vm.items,"saving":_vm.saving},on:{"save":function($event){return _vm.$emit('save')},"back":function($event){return _vm.$emit('goto-list')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }